export const COST_CREATE = "COST_CREATE";
export const COSTS = "COSTS";
export const COST_UPDATE = "COST_UPDATE";
export const COST_DELETE = "DELETE";

export const COST_TYPE_CREATE = "COST_TYPE_CREATE";
export const COSTTYPES = "COSTTYPES";
export const COST_TYPE_UPDATE = "COST_TYPE_UPDATE";
export const COST_TYPE_DELETE = "COST_TYPE_DELETE";

/* cost */

export const createCost = (data,op) =>{
  return {
    type: COST_CREATE,
    payload:data,
    optype:op
  };
};

export const getCosts = (data,op) =>{
    return {
      type: COSTS,
      payload:data,
      optype:op
    };
};



export const updateCost = data =>{
  return {
    type: COST_UPDATE,
    payload:data
  };
};



/* costs types */

export const getCostTypes = (data,op) =>{
  return {
    type: COSTTYPES,
    payload:data,
    optype:op
  };
};
